// @flow

const forceFetch = (state: * = null, action: *) => {
  return action.type === "API_FETCH_ERROR" ? action.message : state;
};

export default forceFetch;
